(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.messages', [
        'uwAgenda.help',
        'uwAgenda.global',
        'uwAgenda.agenda'
    ]);
    module.config(['$stateProvider', 'HelpCategoryEnum', MessageSettingsConfig]);
    module.constant('MessageType', {
        "Email": { name: "Email", value: 1 },
        "IncomingSMS": { name: "IncomingSMS", value: 2 },
        "OutgoingSMSByUser": { name: "OutgoingSMSByUser", value: 3 },
        "OutgoingSMSByServer": { name: "OutgoingSMSByServer", value: 4 },
        "IncomingCall": { name: "IncomingCall", value: 5 },
        "OutgoingCallToClient": { name: "OutgoingCallToClient", value: 6 },
        "OutgoingCallToPatientInvoiced": { name: "OutgoingCallToPatientInvoiced", value: 7 },
        "OutgoingCallToPatientNotInvoiced": { name: "OutgoingCallToPatientNotInvoiced", value: 8 },
        "OutgoingCallForIVR": { name: "OutgoingCallForIVR", value: 10 },
        "IVRCall": { name: "IVRCall", value: 11 },
        "Fax": { name: "Fax", value: 12 },
        "AICall": { name: "AICall", value: 13 },
        "OperatorAndAICall": { name: "OperatorAndAICall", value: 14 }
    });

    // config
    function MessageSettingsConfig($stateProvider, HelpCategoryEnum) {
        $stateProvider
            .state('Home.Messages', {
                url: 'Messages',
                templateUrl: '/app/settings/messages/templates/message-settings.template.html',
                resolve: {
                    deps: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load({
                            name: 'uwAgenda Messages',
                            serie: true,
                            insertBefore: '#ng_load_plugins_before',
                            files: [
                                '/assets/lib/lazy-loaded/profile.css',
                                '/assets/lib/lazy-loaded/todo-2.min.css',
                                '/assets/lib/lazy-loaded/bootstrap-timepicker.min.css',

                                '/assets/lib/lazy-loaded/todo-2.min.js',
                                '/assets/lib/lazy-loaded/jquery.sparkline.min.js',
                                '/assets/lib/lazy-loaded/bootstrap-timepicker.min.js',

                                '/assets/lib/lazy-loaded/profile.min.js'
                            ]
                        });
                    }]
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'settings' | translate}}"
                }
            })
            .state('Home.Messages.Incoming', {
                url: '/Incoming',
                templateUrl: '/app/settings/messages/templates/message-view.template.html',
                controller: 'MessageViewController',
                controllerAs: 'vm',
                params: {
                    helpCategory: HelpCategoryEnum.CallsMessages,
                    today: false
                },
                resolve: {
                    today: ['$stateParams', 'DateService', today],
                    messages: ['MessageService', 'SharedAgendaService', 'MessageType', 'DateService', function (MessageService, SharedAgendaService, MessageType, DateService) {
                        if (SharedAgendaService.currentUser() !== null) {
                            const types = [MessageType.IncomingCall.value, MessageType.Fax.value, MessageType.AICall.value, MessageType.OperatorAndAICall.value];
                            return MessageService.query(SharedAgendaService.currentUser().id, types, DateService.data.date);
                        }
                        else {
                            return null;
                        }
                    }],
                    messageTypes: ['MessageType', function (MessageType) {
                        const types = [MessageType.IncomingCall, MessageType.Fax, MessageType.AICall, MessageType.OperatorAndAICall];
                        return types;
                    }]
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'incoming_calls' | translate}}"
                }
            })
            .state('Home.Messages.Forwarded', {
                url: '/Forwarded',
                templateUrl: '/app/settings/messages/templates/message-view.template.html',
                controller: 'MessageViewController',
                controllerAs: 'vm',
                params: {
                    helpCategory: HelpCategoryEnum.CallsMessages,
                    today: false
                },
                resolve: {
                    today: ['$stateParams', 'DateService', today],
                    messages: ['MessageService', 'SharedAgendaService', 'MessageType', 'DateService', function (MessageService, SharedAgendaService, MessageType, DateService) {
                        if (SharedAgendaService.currentUser() !== null) {
                            var types = [MessageType.OutgoingCallToClient.value];
                            return MessageService.query(SharedAgendaService.currentUser().id, types, DateService.data.date);
                        }
                        else { return null; }
                    }],
                    messageTypes: ['MessageType', function (MessageType) {
                        var types = [MessageType.OutgoingCallToClient];
                        return types;
                    }]
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'forwarded_calls' | translate}}"
                }
            })
            .state('Home.Messages.Outgoing', {
                url: '/Outgoing',
                templateUrl: '/app/settings/messages/templates/message-view.template.html',
                controller: 'MessageViewController',
                controllerAs: 'vm',
                params: {
                    helpCategory: HelpCategoryEnum.CallsMessages,
                    today: false
                },
                resolve: {
                    today: ['$stateParams', 'DateService', today],
                    messages: ['MessageService', 'SharedAgendaService', 'MessageType', 'DateService', function (MessageService, SharedAgendaService, MessageType, DateService) {
                        if (SharedAgendaService.currentUser() !== null)
                            return MessageService.query(SharedAgendaService.currentUser().id, [MessageType.OutgoingCallToPatientInvoiced.value], DateService.data.date);
                        else
                            return null;
                    }],
                    messageTypes: ['MessageType', function (MessageType) {
                        return [MessageType.OutgoingCallToClient, MessageType.OutgoingCallToPatientInvoiced];
                    }]
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'outgoing_calls' | translate}}"
                }
            })
            .state('Home.Messages.Text', {
                url: '/Text',
                templateUrl: '/app/settings/messages/templates/message-view.template.html',
                controller: 'MessageViewController',
                controllerAs: 'vm',
                params: {
                    helpCategory: HelpCategoryEnum.CallsMessages,
                    today: false
                },
                resolve: {
                    today: ['$stateParams', 'DateService', today],
                    messages: ['MessageService', 'SharedAgendaService', 'MessageType', 'DateService', function (MessageService, SharedAgendaService, MessageType, DateService) {
                        if (SharedAgendaService.currentUser() !== null)
                            return MessageService.query(SharedAgendaService.currentUser().id, [MessageType.OutgoingSMSByUser.value, MessageType.OutgoingSMSByServer.value], DateService.data.date);
                        else
                            return null;
                    }],
                    messageTypes: ['MessageType', function (MessageType) {
                        return [MessageType.OutgoingSMSByUser, MessageType.OutgoingSMSByServer];
                    }]
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'text_messages' | translate}}"
                }
            })
            .state('Home.Messages.Online', {
                url: '/Online',
                templateUrl: '/app/settings/messages/templates/message-view.template.html',
                controller: 'MessageViewController',
                controllerAs: 'vm',
                params: {
                    helpCategory: HelpCategoryEnum.CallsMessages,
                    today: false
                },
                resolve: {
                    today: ['$stateParams', 'DateService', today],
                    messages: ['AppointmentService', 'SharedAgendaService', 'DateService', function (AppointmentService, SharedAgendaService, DateService) {
                        if (SharedAgendaService.currentUser() !== null)
                            return AppointmentService.getOnlineBookings(SharedAgendaService.data.currentAgenda.id, DateService.data.date, false);
                        else
                            return null;
                    }],
                    messageTypes: function () {
                        return null;
                    }
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'online_bookings' | translate}}"
                }
            });

        // select today in calendar
        function today($stateParams, DateService) {
            // go to "TODAY" if param is set
            if ($stateParams.today && $stateParams.today === true) {
                // reset parameter
                $stateParams.today = false;
                return DateService.today();
            } //if
        } // today


    }
})();